import authConfig from "emun.auth/auth.config"; //get shared
import basicController from "servicestack/basic.controller.properties";

export default class VerifyEmailTinController {
  constructor($scope) {
    basicController(this);
    const $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    $ctrl.config = authConfig;
    $ctrl.processed = false;
    $scope.$watch(
      () => $ctrl.email,
      () => {
        if (!$ctrl.email) $ctrl.processed = false;
      }
    );
  }

  queryRegistrationEmails() {
    const $ctrl = this;
    const { request } = $ctrl;
    return $ctrl.bus
      .read(`QueryRegistrationEmails/${request.email}`)
      .then(({ data }) => {
        if (data.length) {
          const [retailerId] = data;
          request.retailerId = retailerId;
        }
      });
  }

  gotoRegistration() {
    const $ctrl = this;
    if ($ctrl.tinResponse && $ctrl.tinResponse.tin) {
      $ctrl.registrationUrl = $ctrl.registrationUrl.replace("?tin", "?tin=" + $ctrl.tin)
    }
    location.href = $ctrl.registrationUrl;
  }
  gotoLogin() {
    const $ctrl = this;
    location.href = $ctrl.loginUrl;
  }
  verifyTin() {
    const $ctrl = this;
    $ctrl.tinResponse = {};
    $ctrl.bus.send("TinCheck.json", {tin: $ctrl.tin}).then(function(res) {
      if (res.data.results.length > 0) {
        $ctrl.tinResponse = res.data.results[0];
      } else {
        $ctrl.bus.send("Middesk/TinCheck.json", {
          name: $ctrl.companyName,
          tin: $ctrl.tin
        }).then(function(res) {
          $ctrl.tinResponse = res.data;

        });
      }
    })
  }
  submit() {
    const $ctrl = this;
    delete $ctrl.user;
    delete $ctrl.retailer;
    $ctrl.bus
      .read(`QueryUserEmail.json`, { email: $ctrl.email })
      .then(({ data }) => {
        if (data.results.length) {
          $ctrl.user = data.results[0];
          $ctrl.processed = true;
        } else {
          $ctrl.bus
            .read(`QueryRegistrationEmails/${$ctrl.email}`)
            .then(({ data }) => {
              console.debug("QueryRegistrationEmails", data);
                if (data.length) {
                    $ctrl.retailerId = data[0];
                    console.debug(
                        "QueryRegistrationEmailsResults",
                        $ctrl.retailerId
                    );
                    $ctrl.bus
                        .read(`GetRetailer.json?Id=${$ctrl.retailerId}`)
                        .then(({ data }) => {
                            if (data.results.length) {
                                $ctrl.retailer = data.results[0];
                            } else {
                                //$ctrl.gotoRegistration();
                            }
                        });
                } else {
                    //$ctrl.gotoRegistration();
                }
              $ctrl.processed = true;
            });
        }
      });
  }

  setFocus(id) {
    let $ctrl = this;
    setTimeout(function () {
      var element = window.document.getElementById(id);
      if (element) {
        element.focus();
      }
    }, 500);
  }
}
